import React from 'react';
import axios from 'axios';
import { useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import styles from './Home.module.css';
import { set } from 'mongoose';


function SignUp() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({});
    const [isEmailTaken, setIsEmailTaken] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(window.innerWidth < 768); // State for tracking collapsed status

useEffect(() => {
  function handleResize() {
    setIsCollapsed(window.innerWidth < (768 ));
  }

  window.addEventListener('resize', handleResize);

  return () => {
    window.removeEventListener('resize', handleResize);
  };
  }, []);

    const navigate = useNavigate();

    const validateEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };

    const validateForm = () => {
      const errors = {};
  
      if (!username) {
        errors.username = '⚠️Username is required';
      }

      if (!validateEmail(username)) {
        errors.username = '⚠️Please enter a valid email';
      }
  
      if (!password) {
        errors.password = '⚠️Password is required';
      } else if (password.length < 6) {
        errors.password = '⚠️Password must be at least 6 characters long';
      }
  
      if (!confirmPassword) {
        errors.confirmPassword = '⚠️Confirm password is required';
      } else if (password !== confirmPassword) {
        errors.confirmPassword = '⚠️Passwords do not match';
      }
  
      setErrors(errors);
      return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (event) => {
      event.preventDefault();
      setIsEmailTaken(false);
      
      if(!validateForm()) {
        return;
      }
      await checkEmailAvailability();
      if(isEmailTaken) {
        return;
      }
      axios.post('/api/signup', {
        username,
        password
      })
      .then(response => {
        if (response.status === 200) {
            const token = response.data;
            const user = jwtDecode(token).user;
            localStorage.setItem('token', token.toString());
            localStorage.setItem('username', user.username.toString());
            localStorage.setItem('_id', user._id.toString());
            localStorage.setItem('isSubscribed', false);
            navigate('/dashboard');
        } else if (response.status === 400){
          setIsEmailTaken(true);
        } 
        else {
          console.log('Error signing up');
          throw new Error('Error signing up');
        }
      })
      .catch(error => {
        console.error(error);
      });
    };

    const checkEmailAvailability = async () => {
      try {
        const response = await axios.post('/api/check-email', { username: username });
        const errors = {};
        
        if(response.data.isTaken){
          errors.email = '⚠️Email already exists';
          setErrors(errors);
        }
        setIsEmailTaken(response.data.isTaken);
      } catch (error) {
        console.error('Error checking email availability:', error);
        // Handle error
      }
    };

    return (
      <div className={`container-fluid`}>
        <div className={`row`} style={{ height: '100vh' }}>
          {!isCollapsed ? (
            <div
              className={`col-md-7 justify-content-center d-flex flex-column`}
              style={{ background: '#193551' }}
            >
              <div className={`row`}>
                <div
                  className={`col-md-12 justify-content-center d-flex flex-column align-items-center`}
                >
                  <h1
                    className={"bigboldwhite"}
                    style={{ width: '70%' }}
                  >
                    Amplify your content on all platforms with{' '}
                    <span
                      className={"bigboldyellow"}
                      style={{ fontSize: 'inherit' }}
                    >
                      superstream!
                    </span>
                  </h1>
                </div>
              </div>
              <div className={`row`}>
                <div
                  className={`col-md-12 justify-content-center d-flex flex-column align-items-center`}
                >
                  <img
                    style={{ width: '60%' }}
                    src="images/venndiagram.png"
                    alt="Venn Diagram"
                  ></img>
                </div>
              </div>
              <div className={`row justify-content-center`}>
                <div className={`col-md-12 d-flex justify-content-center`}>
                  <div className={`row justify-content-center`}>
                    <div className={`col-md-3 d-flex justify-content-center`}>
                      <a
                        href="https://twitter.com/superstreamco"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          style={{ width: '50px', padding: '2px' }}
                          src="images/twitterwhite.png"
                          alt="Twitter"
                        ></img>
                      </a>
                    </div>
    
                    <div className={`col-md-3 d-flex justify-content-center`}>
                      <a
                        href="https://instagram.com/superstreamco"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          style={{ width: '50px', padding: '2px' }}
                          src="images/instawhite.png"
                          alt="Instagram"
                        ></img>
                      </a>
                    </div>
    
                    <div className={`col-md-3 d-flex justify-content-center`}>
                      <a
                        href="https://www.tiktok.com/@superstreamco"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          style={{ width: '50px', padding: '2px' }}
                          src="images/tiktokwhite.png"
                          alt="TikTok"
                        ></img>
                      </a>
                    </div>
    
                    <div className={`col-md-3 d-flex justify-content-center`}>
                      <a
                        href="https://youtube.com/channel/UCdxKHziPMLV5r2D40ABdNeQ"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          style={{ width: '50px', padding: '2px' }}
                          src="images/youtubewhite.png"
                          alt="YouTube"
                        ></img>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
          <div
            className={`col-md-5 justify-content-center d-flex flex-column`}
            style={{ background: '#005293' }}
          >
            <div className={`row`}>
              <div
                className={`col-md-12 justify-content-center d-flex flex-column align-items-center`}
              >
                <a className="justify-content-center d-flex" href="/">
                  <img
                    style={{ width: '75%' }}
                    src="images/BANNER.png"
                    alt="Banner"
                  ></img>
                </a>
              </div>
            </div>
            <div className={`row`}>
              <div
                className={`col-md-12 d-flex justify-content-center bigboldwhite`}
                style={{ paddingTop: '5%' }}
              >
                <h1 style={{ fontFamily: 'Russo', color: 'white' }}>Sign Up</h1>
              </div>
            </div>
            <div className={`row`}>
              <div className={`col-md-12`}>
                <form onSubmit={handleSubmit}>
                  <div className="whiteBorder" >
                    <div className="test" style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                      <div className="row">
                        <div className="col-md-12 text-left">
                          <p style={{ textAlign: 'center', color: 'white' }}>Email</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 justify-content-center d-flex flex-column align-items-center">
                          <input
                            style={{
                              width: '70%',
                              borderRadius: '18px',
                              border: '2px solid #ccc',
                              paddingLeft: '2%',
                              paddingRight: '2%',
                            }}
                            type="text"
                            value={username}
                            onChange={(event) => setUsername(event.target.value)}
                          />
                        </div>
                      </div>
                      {errors.username && (
                        <div className="row">
                          <div className="col-md-12 justify-content-center d-flex flex-column align-items-center">
                            <span style={{color: "white"}}>{errors.username}</span>
                          </div>
                        </div>
                      )}
                    </div>
    
                    <div className="test" style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                      <div className="row">
                        <div className="col-md-12">
                          <p style={{ textAlign: 'center', color: 'white' }}>Password</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 justify-content-center d-flex flex-column align-items-center">
                          <input
                            style={{
                              width: '70%',
                              borderRadius: '18px',
                              border: '2px solid #ccc',
                              paddingLeft: '2%',
                              paddingRight: '2%',
                            }}
                            type="password"
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                          />
                        </div>
                      </div>
                      {errors.password && (
                        <div className="row">
                          <div className="col-md-12 justify-content-center d-flex flex-column align-items-center">
                            <span style={{color: "white"}}>{errors.password}</span>
                          </div>
                        </div>
                      )}
                    </div>
    
                    <div className="test" style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                      <div className="row">
                        <div className="col-md-12">
                          <p style={{ textAlign: 'center', color: 'white' }}>Confirm Password</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 justify-content-center d-flex flex-column align-items-center">
                          <input
                            style={{
                              width: '70%',
                              borderRadius: '18px',
                              border: '2px solid #ccc',
                              paddingLeft: '2%',
                              paddingRight: '2%',
                            }}
                            type="password"
                            value={confirmPassword}
                            onChange={(event) => setConfirmPassword(event.target.value)}
                          />
                        </div>
                      </div>
                      {errors.confirmPassword && (
                        <div className="row">
                          <div className="col-md-12 justify-content-center d-flex flex-column align-items-center">
                            <span style={{color: "white"}}>{errors.confirmPassword}</span>
                          </div>
                        </div>
                      )}
                    </div>
    
                    <div className="row">
                      <div className="col-md-12 justify-content-center d-flex flex-column align-items-center">
                        <button
                          onClick={handleSubmit}
                          type="submit"
                          style={{
                            width: '70%',
                            marginTop: '5%',
                            marginBlock: '5%',
                          }}
                        >
                          Sign Up
                        </button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 justify-content-center d-flex flex-column align-items-center" style={{ paddingTop: '10%' }}>
                        <p style={{ textAlign: 'center', color: 'white' }}>
                          Already have an account? <br />
                          <a
                            href="/login"
                            style={{
                              textAlign: 'center',
                              color: '#FECB00',
                              textDecoration: 'underline',
                              textDecorationColor: '#FECB00',
                            }}
                          >
                            Log in now!
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    
  }

export default SignUp;
